import './App.css';
import { Footer } from './Components/Footer/Footer';
import { Hero } from './Components/Hero/Hero';
import { Join } from './Components/Join/Join';
import { Plans } from './Components/Plans/Plans';
import { Program } from './Components/Programs/Program';
import { Reason } from './Components/Reason/Reason';
import { Testimonial } from './Components/Testimonial/Testimonial';
function App() {
  return (
    <div className="App">
          <Hero/>
          <Program/>
          <Reason/>
          <Plans/>
          <Testimonial/>
          <Join/>
          <Footer/>
    </div>
  );
}

export default App;
